<template>
  <div>
    <common-dialog
      ref="dialog"
      width="350px"
      show-save-button
      unit="金额"
      id-key="RechargeTempId"
      form-label-width="60px"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="金额" prop="Amount">
              <el-input size="mini" v-model="data.Amount" v-num placeholder="请填写金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sort">
              <el-input-number :min="0" v-model="data.Sort"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RechargeTempId: 0,
        TempType: 0, //话费/食堂
        Amount: null,
        Sort: 0,
      },
      api: require("@/api/consume/rechargetemp").default,
      isMB: this.$store.state.isMB,
      rules: {
        Amount: [{ required: true, message: "请填写金额" }],
        Sort: [
          { required: true, message: "请填写序号" },
          { validator: this.$commonJs.validateRules.int },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSort(0).then((res) => {
        this.data.Sort = res.Data;
      });
    },
  },
};
</script>
<style lang="scss">
</style>